export const target_images = [
	{ index: 0, category: 'target', image: '../assets/1.webp/T1_01.webp' },
	{ index: 1, category: 'target', image: '../assets/2.webp/T2_01.webp' },
	{ index: 2, category: 'target', image: '../assets/3.webp/T3_01.webp' },
    { index: 3, category: 'target', image: '../assets/4.webp/T4_01.webp' },
    { index: 4, category: 'target', image: '../assets/5.webp/T5_01.webp' },
    { index: 5, category: 'target', image: '../assets/6.webp/T6_01.webp' },
    { index: 6, category: 'target', image: '../assets/7.webp/T7_01.webp' },
    { index: 7, category: 'target', image: '../assets/8.webp/T8_01.webp' },
    { index: 8, category: 'target', image: '../assets/9.webp/T9_01.webp' },
    { index: 9, category: 'target', image: '../assets/10.webp/T10_01.webp' },
    { index: 10, category: 'target', image: '../assets/11.webp/T11_01.webp' },
    { index: 11, category: 'target', image: '../assets/12.webp/T12_01.webp' },
    { index: 12, category: 'target', image: '../assets/13.webp/T13_01.webp' },
];





export const non_target_images = [
{index: 0, category: 'non-target', image: '../assets/1.webp/C1_01.webp',},
{index: 1, category: 'non-target', image: '../assets/1.webp/C1_02.webp',},
{index: 2, category: 'non-target', image: '../assets/1.webp/C1_03.webp',},
{index: 3, category: 'non-target', image: '../assets/1.webp/C1_04.webp',},
{index: 4, category: 'non-target', image: '../assets/1.webp/C1_05.webp',},
{index: 5, category: 'non-target', image: '../assets/1.webp/C1_06.webp',},
{index: 6, category: 'non-target', image: '../assets/1.webp/C1_07.webp',},
{index: 7, category: 'non-target', image: '../assets/1.webp/C1_08.webp',},
{index: 8, category: 'non-target', image: '../assets/2.webp/C2_01.webp',},
{index: 9, category: 'non-target', image: '../assets/2.webp/C2_02.webp',},
{index: 10, category: "non-target", image: "../assets/2.webp/C2_03.webp", },
{index: 11, category: 'non-target', image: '../assets/2.webp/C2_04.webp',},
{index: 12, category: 'non-target', image: '../assets/2.webp/C2_05.webp',},
{index: 13, category: 'non-target', image: '../assets/2.webp/C2_06.webp',},
{index: 14, category: 'non-target', image: '../assets/2.webp/C2_07.webp',},
{index: 15, category: 'non-target', image: '../assets/2.webp/C2_08.webp',},
{index: 16, category: 'non-target', image: '../assets/3.webp/C3_01.webp',},
{index: 17, category: 'non-target', image: '../assets/3.webp/C3_02.webp',},
{index: 18, category: 'non-target', image: '../assets/3.webp/C3_03.webp',},
{index: 19, category: 'non-target', image: '../assets/3.webp/C3_04.webp',},
{index: 20, category: 'non-target', image: '../assets/3.webp/C3_05.webp',},
{index: 21, category: 'non-target', image: '../assets/3.webp/C3_06.webp',},
{index: 22, category: 'non-target', image: '../assets/3.webp/C3_07.webp',},
{index: 23, category: 'non-target', image: '../assets/3.webp/C3_08.webp',},

{index: 24, category: 'non-target', image: '../assets/4.webp/C4_01.webp',},
{index: 25, category: 'non-target', image: '../assets/4.webp/C4_02.webp',},
{index: 26, category: 'non-target', image: '../assets/4.webp/C4_03.webp',},
{index: 27, category: 'non-target', image: '../assets/4.webp/C4_04.webp',},
{index: 28, category: 'non-target', image: '../assets/4.webp/C4_05.webp',},
{index: 29, category: 'non-target', image: '../assets/4.webp/C4_06.webp',},
{index: 31, category: 'non-target', image: '../assets/4.webp/C4_08.webp',},
{index: 30, category: 'non-target', image: '../assets/4.webp/C4_07.webp',},
{index: 33, category: 'non-target', image: '../assets/4.webp/C4_10.webp',},
{index: 32, category: 'non-target', image: '../assets/4.webp/C4_09.webp',},
{index: 35, category: 'non-target', image: '../assets/4.webp/C4_12.webp',},
{index: 34, category: 'non-target', image: '../assets/4.webp/C4_11.webp',},
{index: 37, category: 'non-target', image: '../assets/4.webp/C4_14.webp',},
{index: 36, category: 'non-target', image: '../assets/4.webp/C4_13.webp',},
{index: 38, category: 'non-target', image: '../assets/4.webp/C4_15.webp',},
{index: 39, category: 'non-target', image: '../assets/4.webp/C4_16.webp',},
{index: 40, category: 'non-target', image: '../assets/4.webp/C4_17.webp',},
{index: 41, category: 'non-target', image: '../assets/4.webp/C4_18.webp',},
{index: 42, category: 'non-target', image: '../assets/4.webp/C4_19.webp',},
{index: 43, category: 'non-target', image: '../assets/4.webp/C4_20.webp',},
{index: 44, category: 'non-target', image: '../assets/4.webp/C4_21.webp',},
{index: 45, category: 'non-target', image: '../assets/4.webp/C4_22.webp',},
{index: 46, category: 'non-target', image: '../assets/4.webp/C4_23.webp',},
{index: 47, category: 'non-target', image: '../assets/4.webp/C4_24.webp',},
{index: 48, category: 'non-target', image: '../assets/4.webp/C4_25.webp',},
{index: 49, category: 'non-target', image: '../assets/4.webp/C4_26.webp',},
{index: 50, category: 'non-target', image: '../assets/4.webp/C4_27.webp',},
{index: 51, category: 'non-target', image: '../assets/4.webp/C4_28.webp',},
{index: 52, category: 'non-target', image: '../assets/4.webp/C4_29.webp',},
{index: 53, category: 'non-target', image: '../assets/4.webp/C4_30.webp',},
{index: 54, category: 'non-target', image: '../assets/4.webp/C4_31.webp',},
{index: 55, category: 'non-target', image: '../assets/4.webp/C4_32.webp',},
{index: 56, category: 'non-target', image: '../assets/4.webp/C4_33.webp',},
{index: 57, category: 'non-target', image: '../assets/4.webp/C4_34.webp',},
{index: 58, category: 'non-target', image: '../assets/4.webp/C4_35.webp',},

{index: 59, category: 'non-target', image: '../assets/5.webp/C5_01.webp',},
{index: 60, category: 'non-target', image: '../assets/5.webp/C5_02.webp',},
{index: 61, category: 'non-target', image: '../assets/5.webp/C5_03.webp',},
{index: 62, category: 'non-target', image: '../assets/5.webp/C5_04.webp',},
{index: 63, category: 'non-target', image: '../assets/5.webp/C5_05.webp',},
{index: 64, category: 'non-target', image: '../assets/5.webp/C5_06.webp',},
{index: 65, category: 'non-target', image: '../assets/5.webp/C5_07.webp',},
{index: 66, category: 'non-target', image: '../assets/5.webp/C5_08.webp',},
{index: 67, category: 'non-target', image: '../assets/5.webp/C5_09.webp',},
{index: 68, category: 'non-target', image: '../assets/5.webp/C5_10.webp',},
{index: 69, category: 'non-target', image: '../assets/5.webp/C5_11.webp',},
{index: 70, category: 'non-target', image: '../assets/5.webp/C5_12.webp',},
{index: 71, category: 'non-target', image: '../assets/5.webp/C5_13.webp',},
{index: 72, category: 'non-target', image: '../assets/5.webp/C5_14.webp',},
{index: 73, category: 'non-target', image: '../assets/5.webp/C5_15.webp',},
{index: 74, category: 'non-target', image: '../assets/5.webp/C5_16.webp',},
{index: 75, category: 'non-target', image: '../assets/5.webp/C5_17.webp',},
{index: 76, category: 'non-target', image: '../assets/5.webp/C5_18.webp',},
{index: 77, category: 'non-target', image: '../assets/5.webp/C5_19.webp',},
{index: 78, category: 'non-target', image: '../assets/5.webp/C5_20.webp',},
{index: 79, category: 'non-target', image: '../assets/5.webp/C5_21.webp',},
{index: 80, category: 'non-target', image: '../assets/5.webp/C5_22.webp',},
{index: 81, category: 'non-target', image: '../assets/5.webp/C5_23.webp',},
{index: 82, category: 'non-target', image: '../assets/5.webp/C5_24.webp',},
{index: 83, category: 'non-target', image: '../assets/5.webp/C5_25.webp',},
{index: 84, category: 'non-target', image: '../assets/5.webp/C5_26.webp',},
{index: 85, category: 'non-target', image: '../assets/5.webp/C5_27.webp',},
{index: 86, category: 'non-target', image: '../assets/5.webp/C5_28.webp',},
{index: 87, category: 'non-target', image: '../assets/5.webp/C5_29.webp',},
{index: 88, category: 'non-target', image: '../assets/5.webp/C5_30.webp',},
{index: 89, category: 'non-target', image: '../assets/5.webp/C5_31.webp',},
{index: 90, category: 'non-target', image: '../assets/5.webp/C5_32.webp',},
{index: 91, category: 'non-target', image: '../assets/5.webp/C5_33.webp',},
{index: 92, category: 'non-target', image: '../assets/5.webp/C5_34.webp',},
{index: 93, category: 'non-target', image: '../assets/5.webp/C5_35.webp',},

{index: 94, category: 'non-target', image: '../assets/6.webp/C6_01.webp',},
{index: 95, category: 'non-target', image: '../assets/6.webp/C6_02.webp',},
{index: 96, category: 'non-target', image: '../assets/6.webp/C6_03.webp',},
{index: 97, category: 'non-target', image: '../assets/6.webp/C6_04.webp',},
{index: 98, category: 'non-target', image: '../assets/6.webp/C6_05.webp',},
{index: 99, category: 'non-target', image: '../assets/6.webp/C6_06.webp',},
{index: 100, category: 'non-target', image:'../assets/6.webp/C6_07.webp',},
{index: 101, category: 'non-target', image: '../assets/6.webp/C6_08.webp',},
{index: 102, category: 'non-target', image: '../assets/6.webp/C6_09.webp',},
{index: 103, category: 'non-target', image: '../assets/6.webp/C6_10.webp',},
{index: 104, category: 'non-target', image: '../assets/6.webp/C6_11.webp',},
{index: 105, category: 'non-target', image: '../assets/6.webp/C6_12.webp',},
{index: 106, category: 'non-target', image: '../assets/6.webp/C6_13.webp',},
{index: 107, category: 'non-target', image: '../assets/6.webp/C6_14.webp',},
{index: 108, category: 'non-target', image: '../assets/6.webp/C6_15.webp',},
{index: 109, category: 'non-target', image: '../assets/6.webp/C6_16.webp',},
{index: 110, category: 'non-target', image: '../assets/6.webp/C6_17.webp',},
{index: 111, category: 'non-target', image: '../assets/6.webp/C6_18.webp',},
{index: 112, category: 'non-target', image: '../assets/6.webp/C6_19.webp',},
{index: 113, category: 'non-target', image: '../assets/6.webp/C6_20.webp',},
{index: 114, category: 'non-target', image: '../assets/6.webp/C6_21.webp',},
{index: 115, category: 'non-target', image: '../assets/6.webp/C6_22.webp',},
{index: 116, category: 'non-target', image: '../assets/6.webp/C6_23.webp',},
{index: 117, category: 'non-target', image: '../assets/6.webp/C6_24.webp',},
{index: 118, category: 'non-target', image: '../assets/6.webp/C6_25.webp',},
{index: 119, category: 'non-target', image: '../assets/6.webp/C6_26.webp',},
{index: 120, category: 'non-target', image: '../assets/6.webp/C6_27.webp',},
{index: 121, category: 'non-target', image: '../assets/6.webp/C6_28.webp',},
{index: 122, category: 'non-target', image: '../assets/6.webp/C6_29.webp',},
{index: 123, category: 'non-target', image: '../assets/6.webp/C6_30.webp',},
{index: 124, category: 'non-target', image: '../assets/6.webp/C6_31.webp',},
{index: 125, category: 'non-target', image: '../assets/6.webp/C6_32.webp',},
{index: 126, category: 'non-target', image: '../assets/6.webp/C6_33.webp',},
{index: 127, category: 'non-target', image: '../assets/6.webp/C6_34.webp',},
{index: 128, category: 'non-target', image: '../assets/6.webp/C6_35.webp',},

{index: 129, category: 'non-target', image: '../assets/7.webp/C7_01.webp',},
{index: 130, category: 'non-target', image: '../assets/7.webp/C7_02.webp',},
{index: 131, category: 'non-target', image: '../assets/7.webp/C7_03.webp',},
{index: 132, category: 'non-target', image: '../assets/7.webp/C7_04.webp',},
{index: 133, category: 'non-target', image: '../assets/7.webp/C7_05.webp',},
{index: 134, category: 'non-target', image: '../assets/7.webp/C7_06.webp',},
{index: 135, category: 'non-target', image: '../assets/7.webp/C7_07.webp',},
{index: 136, category: 'non-target', image: '../assets/7.webp/C7_08.webp',},
{index: 137, category: 'non-target', image: '../assets/7.webp/C7_09.webp',},
{index: 138, category: 'non-target', image: '../assets/7.webp/C7_10.webp',},
{index: 139, category: 'non-target', image: '../assets/7.webp/C7_11.webp',},
{index: 140, category: 'non-target', image: '../assets/7.webp/C7_12.webp',},
{index: 141, category: 'non-target', image: '../assets/7.webp/C7_13.webp',},
{index: 142, category: 'non-target', image: '../assets/7.webp/C7_14.webp',},
{index: 143, category: 'non-target', image: '../assets/7.webp/C7_15.webp',},
{index: 144, category: 'non-target', image: '../assets/7.webp/C7_16.webp',},
{index: 145, category: 'non-target', image: '../assets/7.webp/C7_17.webp',},
{index: 146, category: 'non-target', image: '../assets/7.webp/C7_18.webp',},
{index: 147, category: 'non-target', image: '../assets/7.webp/C7_19.webp',},
{index: 148, category: 'non-target', image: '../assets/7.webp/C7_20.webp',},
{index: 149, category: 'non-target', image: '../assets/7.webp/C7_21.webp',},
{index: 150, category: 'non-target', image: '../assets/7.webp/C7_22.webp',},
{index: 151, category: 'non-target', image: '../assets/7.webp/C7_23.webp',},
{index: 152, category: 'non-target', image: '../assets/7.webp/C7_24.webp',},
{index: 153, category: 'non-target', image: '../assets/7.webp/C7_25.webp',},
{index: 154, category: 'non-target', image: '../assets/7.webp/C7_26.webp',},
{index: 155, category: 'non-target', image: '../assets/7.webp/C7_27.webp',},
{index: 156, category: 'non-target', image: '../assets/7.webp/C7_28.webp',},
{index: 157, category: 'non-target', image: '../assets/7.webp/C7_29.webp',},
{index: 158, category: 'non-target', image: '../assets/7.webp/C7_30.webp',},
{index: 159, category: 'non-target', image: '../assets/7.webp/C7_31.webp',},
{index: 160, category: 'non-target', image: '../assets/7.webp/C7_32.webp',},
{index: 161, category: 'non-target', image: '../assets/7.webp/C7_33.webp',},
{index: 162, category: 'non-target', image: '../assets/7.webp/C7_34.webp',},
{index: 163, category: 'non-target', image: '../assets/7.webp/C7_35.webp',},

{index: 164, category: 'non-target', image: '../assets/8.webp/C8_01.webp',},
{index: 165, category: 'non-target', image: '../assets/8.webp/C8_02.webp',},
{index: 166, category: 'non-target', image: '../assets/8.webp/C8_03.webp',},
{index: 167, category: 'non-target', image: '../assets/8.webp/C8_04.webp',},
{index: 168, category: 'non-target', image: '../assets/8.webp/C8_05.webp',},
{index: 169, category: 'non-target', image: '../assets/8.webp/C8_06.webp',},
{index: 170, category: 'non-target', image: '../assets/8.webp/C8_07.webp',},
{index: 171, category: 'non-target', image: '../assets/8.webp/C8_08.webp',},
{index: 172, category: 'non-target', image: '../assets/8.webp/C8_09.webp',},
{index: 173, category: 'non-target', image: '../assets/8.webp/C8_10.webp',},
{index: 174, category: 'non-target', image: '../assets/8.webp/C8_11.webp',},
{index: 175, category: 'non-target', image: '../assets/8.webp/C8_12.webp',},
{index: 176, category: 'non-target', image: '../assets/8.webp/C8_13.webp',},
{index: 177, category: 'non-target', image: '../assets/8.webp/C8_14.webp',},
{index: 178, category: 'non-target', image: '../assets/8.webp/C8_15.webp',},
{index: 179, category: 'non-target', image: '../assets/8.webp/C8_16.webp',},
{index: 180, category: 'non-target', image: '../assets/8.webp/C8_17.webp',},
{index: 181, category: 'non-target', image: '../assets/8.webp/C8_18.webp',},
{index: 182, category: 'non-target', image: '../assets/8.webp/C8_19.webp',},
{index: 183, category: 'non-target', image: '../assets/8.webp/C8_20.webp',},
{index: 184, category: 'non-target', image: '../assets/8.webp/C8_21.webp',},
{index: 185, category: 'non-target', image: '../assets/8.webp/C8_22.webp',},
{index: 186, category: 'non-target', image: '../assets/8.webp/C8_23.webp',},
{index: 187, category: 'non-target', image: '../assets/8.webp/C8_24.webp',},
{index: 188, category: 'non-target', image: '../assets/8.webp/C8_25.webp',},
{index: 189, category: 'non-target', image: '../assets/8.webp/C8_26.webp',},
{index: 190, category: 'non-target', image: '../assets/8.webp/C8_27.webp',},
{index: 191, category: 'non-target', image: '../assets/8.webp/C8_28.webp',},
{index: 192, category: 'non-target', image: '../assets/8.webp/C8_29.webp',},
{index: 193, category: 'non-target', image: '../assets/8.webp/C8_30.webp',},
{index: 194, category: 'non-target', image: '../assets/8.webp/C8_31.webp',},
{index: 195, category: 'non-target', image: '../assets/8.webp/C8_32.webp',},
{index: 196, category: 'non-target', image: '../assets/8.webp/C8_33.webp',},
{index: 197, category: 'non-target', image: '../assets/8.webp/C8_34.webp',},
{index: 198, category: 'non-target', image: '../assets/8.webp/C8_35.webp',},

{index: 199, category: 'non-target', image: '../assets/9.webp/C9_01.webp',},
{index: 200, category: 'non-target', image: '../assets/9.webp/C9_02.webp',},
{index: 201, category: 'non-target', image: '../assets/9.webp/C9_03.webp',},
{index: 202, category: 'non-target', image: '../assets/9.webp/C9_04.webp',},
{index: 203, category: 'non-target', image: '../assets/9.webp/C9_05.webp',},
{index: 204, category: 'non-target', image: '../assets/9.webp/C9_06.webp',},
{index: 205, category: 'non-target', image: '../assets/9.webp/C9_07.webp',},
{index: 206, category: 'non-target', image: '../assets/9.webp/C9_08.webp',},
{index: 207, category: 'non-target', image: '../assets/9.webp/C9_09.webp',},
{index: 208, category: 'non-target', image: '../assets/9.webp/C9_10.webp',},
{index: 209, category: 'non-target', image: '../assets/9.webp/C9_11.webp',},
{index: 210, category: 'non-target', image: '../assets/9.webp/C9_12.webp',},
{index: 211, category: 'non-target', image: '../assets/9.webp/C9_13.webp',},
{index: 212, category: 'non-target', image: '../assets/9.webp/C9_14.webp',},
{index: 213, category: 'non-target', image: '../assets/9.webp/C9_15.webp',},
{index: 214, category: 'non-target', image: '../assets/9.webp/C9_16.webp',},
{index: 215, category: 'non-target', image: '../assets/9.webp/C9_17.webp',},
{index: 216, category: 'non-target', image: '../assets/9.webp/C9_18.webp',},
{index: 217, category: 'non-target', image: '../assets/9.webp/C9_19.webp',},
{index: 218, category: 'non-target', image: '../assets/9.webp/C9_20.webp',},
{index: 219, category: 'non-target', image: '../assets/9.webp/C9_21.webp',},
{index: 220, category: 'non-target', image: '../assets/9.webp/C9_22.webp',},

{index: 221, category: 'non-target', image: '../assets/9.webp/C9_23.webp',},

{index: 222, category: 'non-target', image: '../assets/9.webp/C9_24.webp',},
{index: 223, category: 'non-target', image: '../assets/9.webp/C9_25.webp',},
{index: 224, category: 'non-target', image: '../assets/9.webp/C9_26.webp',},
{index: 225, category: 'non-target', image: '../assets/9.webp/C9_27.webp',},
{index: 226, category: 'non-target', image: '../assets/9.webp/C9_28.webp',},
{index: 227, category: 'non-target', image: '../assets/9.webp/C9_29.webp',},
{index: 228, category: 'non-target', image: '../assets/9.webp/C9_30.webp',},
{index: 229, category: 'non-target', image: '../assets/9.webp/C9_31.webp',},
{index: 230, category: 'non-target', image: '../assets/9.webp/C9_32.webp',},
{index: 231, category: 'non-target', image: '../assets/9.webp/C9_33.webp',},

{index: 232, category: 'non-target', image: '../assets/9.webp/C9_34.webp',},

{index: 233, category: 'non-target', image: '../assets/9.webp/C9_35.webp',},
{index: 234, category: 'non-target', image: '../assets/10.webp/C10_01.webp', },
{index: 235, category: 'non-target', image: '../assets/10.webp/C10_02.webp', },
{index: 236, category: 'non-target', image: '../assets/10.webp/C10_03.webp', },
{index: 237, category: 'non-target', image: '../assets/10.webp/C10_04.webp', },
{index: 238, category: 'non-target', image: '../assets/10.webp/C10_05.webp', },
{index: 239, category: 'non-target', image: '../assets/10.webp/C10_06.webp', },
{index: 240, category: 'non-target', image: '../assets/10.webp/C10_07.webp', },
{index: 241, category: 'non-target', image: '../assets/10.webp/C10_08.webp', },
{index: 242, category: 'non-target', image: '../assets/10.webp/C10_09.webp', },
{index: 243, category: 'non-target', image: '../assets/10.webp/C10_10.webp', },
{index: 244, category: 'non-target', image: '../assets/10.webp/C10_11.webp', },
{index: 245, category: 'non-target', image: '../assets/10.webp/C10_12.webp', },
{index: 246, category: 'non-target', image: '../assets/10.webp/C10_13.webp', },

{index: 247, category: 'non-target', image: '../assets/10.webp/C10_14.webp', },
{index: 248, category: 'non-target', image: '../assets/10.webp/C10_15.webp', },
{index: 249, category: 'non-target', image: '../assets/10.webp/C10_16.webp', },
{index: 250, category: 'non-target', image: '../assets/10.webp/C10_17.webp', },
{index: 251, category: 'non-target', image: '../assets/10.webp/C10_18.webp', },
{index: 252, category: 'non-target', image: '../assets/10.webp/C10_19.webp', },
{index: 253, category: 'non-target', image: '../assets/10.webp/C10_20.webp', },
{index: 254, category: 'non-target', image: '../assets/10.webp/C10_21.webp', },
{index: 255, category: 'non-target', image: '../assets/10.webp/C10_22.webp', },
{index: 256, category: 'non-target', image: '../assets/10.webp/C10_23.webp', },
{index: 257, category: 'non-target', image: '../assets/10.webp/C10_24.webp', },
{index: 258, category: 'non-target', image: '../assets/10.webp/C10_25.webp', },
{index: 259, category: 'non-target', image: '../assets/10.webp/C10_26.webp', },
{index: 260, category: 'non-target', image: '../assets/10.webp/C10_27.webp', },
{index: 261, category: 'non-target', image: '../assets/10.webp/C10_28.webp', },
{index: 262, category: 'non-target', image: '../assets/10.webp/C10_29.webp', },
{index: 263, category: 'non-target', image: '../assets/10.webp/C10_30.webp', },
{index: 264, category: 'non-target', image: '../assets/10.webp/C10_31.webp', },
{index: 265, category: 'non-target', image: '../assets/10.webp/C10_32.webp', },
{index: 266, category: 'non-target', image: '../assets/10.webp/C10_33.webp', },
{index: 267, category: 'non-target', image: '../assets/10.webp/C10_34.webp', },
{index: 268, category: 'non-target', image: '../assets/10.webp/C10_35.webp', },
{index: 269, category: 'non-target', image: '../assets/11.webp/C11_01.webp', },
{index: 270, category: 'non-target', image: '../assets/11.webp/C11_02.webp', },
{index: 271, category: 'non-target', image: '../assets/11.webp/C11_03.webp', },
{index: 272, category: 'non-target', image: '../assets/11.webp/C11_04.webp', },
{index: 273, category: 'non-target', image: '../assets/11.webp/C11_05.webp', },
{index: 274, category: 'non-target', image: '../assets/11.webp/C11_06.webp', },
{index: 275, category: 'non-target', image: '../assets/11.webp/C11_07.webp', },
{index: 276, category: 'non-target', image: '../assets/11.webp/C11_08.webp', },
{index: 277, category: 'non-target', image: '../assets/11.webp/C11_09.webp', },
{index: 278, category: 'non-target', image: '../assets/11.webp/C11_10.webp', },
{index: 279, category: 'non-target', image: '../assets/11.webp/C11_11.webp', },
{index: 280, category: 'non-target', image: '../assets/11.webp/C11_12.webp', },
{index: 281, category: 'non-target', image: '../assets/11.webp/C11_13.webp', },
{index: 282, category: 'non-target', image: '../assets/11.webp/C11_14.webp', },
{index: 283, category: 'non-target', image: '../assets/11.webp/C11_15.webp', },
{index: 284, category: 'non-target', image: '../assets/11.webp/C11_16.webp', },
{index: 285, category: 'non-target', image: '../assets/11.webp/C11_17.webp', },
{index: 286, category: 'non-target', image: '../assets/11.webp/C11_18.webp', },
{index: 287, category: 'non-target', image: '../assets/11.webp/C11_19.webp', },
{index: 288, category: 'non-target', image: '../assets/11.webp/C11_20.webp', },
{index: 289, category: 'non-target', image: '../assets/11.webp/C11_21.webp', },
{index: 290, category: 'non-target', image: '../assets/11.webp/C11_22.webp', },
{index: 291, category: 'non-target', image: '../assets/11.webp/C11_23.webp', },
{index: 292, category: 'non-target', image: '../assets/11.webp/C11_24.webp', },
{index: 293, category: 'non-target', image: '../assets/11.webp/C11_25.webp', },
{index: 294, category: 'non-target', image: '../assets/11.webp/C11_26.webp', },
{index: 295, category: 'non-target', image: '../assets/11.webp/C11_27.webp', },
{index: 296, category: 'non-target', image: '../assets/11.webp/C11_28.webp', },
{index: 297, category: 'non-target', image: '../assets/11.webp/C11_29.webp', },
{index: 298, category: 'non-target', image: '../assets/11.webp/C11_30.webp', },
{index: 299, category: 'non-target', image: '../assets/11.webp/C11_31.webp', },
{index: 300, category: 'non-target', image: '../assets/11.webp/C11_32.webp', },
{index: 301, category: 'non-target', image: '../assets/11.webp/C11_33.webp', },
{index: 302, category: 'non-target', image: '../assets/11.webp/C11_34.webp', },
{index: 303, category: 'non-target', image: '../assets/11.webp/C11_35.webp', },
{index: 304, category: 'non-target', image: '../assets/12.webp/C12_01.webp', },
{index: 305, category: 'non-target', image: '../assets/12.webp/C12_02.webp', },
{index: 306, category: 'non-target', image: '../assets/12.webp/C12_03.webp', },
{index: 307, category: 'non-target', image: '../assets/12.webp/C12_04.webp', },
{index: 308, category: 'non-target', image: '../assets/12.webp/C12_05.webp', },
{index: 309, category: 'non-target', image: '../assets/12.webp/C12_06.webp', },
{index: 310, category: 'non-target', image: '../assets/12.webp/C12_07.webp', },
{index: 311, category: 'non-target', image: '../assets/12.webp/C12_08.webp', },
{index: 312, category: 'non-target', image: '../assets/12.webp/C12_09.webp', },
{index: 313, category: 'non-target', image: '../assets/12.webp/C12_10.webp', },
{index: 314, category: 'non-target', image: '../assets/12.webp/C12_11.webp', },
{index: 315, category: 'non-target', image: '../assets/12.webp/C12_12.webp', },
{index: 316, category: 'non-target', image: '../assets/12.webp/C12_13.webp', },
{index: 317, category: 'non-target', image: '../assets/12.webp/C12_14.webp', },
{index: 318, category: 'non-target', image: '../assets/12.webp/C12_15.webp', },
{index: 319, category: 'non-target', image: '../assets/12.webp/C12_16.webp', },
{index: 320, category: 'non-target', image: '../assets/12.webp/C12_17.webp', },
{index: 321, category: 'non-target', image: '../assets/12.webp/C12_18.webp', },
{index: 322, category: 'non-target', image: '../assets/12.webp/C12_19.webp', },
{index: 323, category: 'non-target', image: '../assets/12.webp/C12_20.webp', },
{index: 324, category: 'non-target', image: '../assets/12.webp/C12_21.webp', },
{index: 325, category: 'non-target', image: '../assets/12.webp/C12_22.webp', },
{index: 326, category: 'non-target', image: '../assets/12.webp/C12_23.webp', },
{index: 327, category: 'non-target', image: '../assets/12.webp/C12_24.webp', },
{index: 328, category: 'non-target', image: '../assets/12.webp/C12_25.webp', },
{index: 329, category: 'non-target', image: '../assets/12.webp/C12_26.webp', },
{index: 330, category: 'non-target', image: '../assets/12.webp/C12_27.webp', },
{index: 331, category: 'non-target', image: '../assets/12.webp/C12_28.webp', },
{index: 332, category: 'non-target', image: '../assets/12.webp/C12_29.webp', },
{index: 333, category: 'non-target', image: '../assets/12.webp/C12_30.webp', },
{index: 334, category: 'non-target', image: '../assets/12.webp/C12_31.webp', },
{index: 335, category: 'non-target', image: '../assets/12.webp/C12_32.webp', },
{index: 336, category: 'non-target', image: '../assets/12.webp/C12_33.webp', },
{index: 337, category: 'non-target', image: '../assets/12.webp/C12_34.webp', },
{index: 338, category: 'non-target', image: '../assets/12.webp/C12_35.webp', },
{index: 339, category: 'non-target', image: '../assets/13.webp/C13_01.webp', },
{index: 340, category: 'non-target', image: '../assets/13.webp/C13_02.webp', },
{index: 341, category: 'non-target', image: '../assets/13.webp/C13_03.webp', },
{index: 342, category: 'non-target', image: '../assets/13.webp/C13_04.webp', },
{index: 343, category: 'non-target', image: '../assets/13.webp/C13_05.webp', },
{index: 344, category: 'non-target', image: '../assets/13.webp/C13_06.webp', },
{index: 345, category: 'non-target', image: '../assets/13.webp/C13_07.webp', },
{index: 346, category: 'non-target', image: '../assets/13.webp/C13_08.webp', },
{index: 347, category: 'non-target', image: '../assets/13.webp/C13_09.webp', },
{index: 348, category: 'non-target', image: '../assets/13.webp/C13_10.webp', },
{index: 349, category: 'non-target', image: '../assets/13.webp/C13_11.webp', },
{index: 350, category: 'non-target', image: '../assets/13.webp/C13_12.webp', },
{index: 351, category: 'non-target', image: '../assets/13.webp/C13_13.webp', },
{index: 352, category: 'non-target', image: '../assets/13.webp/C13_14.webp', },
{index: 353, category: 'non-target', image: '../assets/13.webp/C13_15.webp', },
{index: 354, category: 'non-target', image: '../assets/13.webp/C13_16.webp', },
{index: 355, category: 'non-target', image: '../assets/13.webp/C13_17.webp', },
{index: 356, category: 'non-target', image: '../assets/13.webp/C13_18.webp', },
{index: 357, category: 'non-target', image: '../assets/13.webp/C13_19.webp', },
{index: 358, category: 'non-target', image: '../assets/13.webp/C13_20.webp', },
{index: 359, category: 'non-target', image: '../assets/13.webp/C13_21.webp', },
{index: 360, category: 'non-target', image: '../assets/13.webp/C13_22.webp', },
{index: 361, category: 'non-target', image: '../assets/13.webp/C13_23.webp', },
{index: 362, category: 'non-target', image: '../assets/13.webp/C13_24.webp', },
{index: 363, category: 'non-target', image: '../assets/13.webp/C13_25.webp', },
{index: 364, category: 'non-target', image: '../assets/13.webp/C13_26.webp', },
{index: 365, category: 'non-target', image: '../assets/13.webp/C13_27.webp', },
{index: 366, category: 'non-target', image: '../assets/13.webp/C13_28.webp', },
{index: 367, category: 'non-target', image: '../assets/13.webp/C13_29.webp', },
{index: 368, category: 'non-target', image: '../assets/13.webp/C13_30.webp', },
{index: 369, category: 'non-target', image: '../assets/13.webp/C13_31.webp', },
{index: 370, category: 'non-target', image: '../assets/13.webp/C13_32.webp', },
{index: 371, category: 'non-target', image: '../assets/13.webp/C13_33.webp', },
{index: 372, category: 'non-target', image: '../assets/13.webp/C13_34.webp', },
{index: 373, category: 'non-target', image: '../assets/13.webp/C13_35.webp',},
];